/* eslint-disable no-unused-vars */

import _ from 'lodash';
import { SelectedCollapseableFilter } from '@components/filters/task-status';
import { SelectedCollapseableFilter as SelectedCollapseableFilter1 } from '@components/collapseable-tree/';
import { SelectedProximityFilter } from '@components/filters/proximity';
import { SelectedDueDateFilter } from '@components/filters/due-date';

import style from './style.module.scss';

const DynamicFilterContainer = ({
  filterConfigs,
  filters,
  unit,
  filterCount = 0,
  resetBtnEvent
}) => {
  const renderFilterComponent = (filter, index) => {
    let filterValue =
      filter.key === 'proximity' && filters?.proximity?.value
        ? { chipText: `Under ${filters.proximity.value || 0} ${unit || 'km'}` }
        : filters[filter.key]?.value || [];

    if (filter.key === 'proximity' && !filters.proximity.value) return null;

    if (['dueDate', 'scheduledDate', 'syncedDate'].includes(filter.key)) {
      if (filterValue.length === 0) {
        return null;
      } else if (_.isArray(filterValue)) {
        if (filterValue?.length > 0 && filterValue?.filter((x) => x)?.length === 0) {
          return null;
        }
      }
    }

    const ComponentType =
      filter.component === 'SelectedCollapseableFilter1'
        ? SelectedCollapseableFilter1
        : filter.component === 'SelectedProximityFilter'
        ? SelectedProximityFilter
        : filter.component === 'SelectedDueDateFilter'
        ? SelectedDueDateFilter
        : SelectedCollapseableFilter;

    return (
      <ComponentType
        key={index}
        chips={filterValue}
        selectedChip={filters[filter.key]?.selected}
        tag={filterValue}
        dynamic
        {...filter}
      />
    );
  };

  return (
    <>
      <div className={style.container}>
        {filterConfigs?.sort((a, b) => a.order - b.order).map(renderFilterComponent)}
      </div>
      {filterCount > 0 && (
        <p className={style.filterCount} onClick={resetBtnEvent}>
          Reset all ({filterCount})
        </p>
      )}
    </>
  );
};

export default DynamicFilterContainer;
